import ab from 'react-redux-hydra';

import { IS_DEV } from 'constants/appConstants';
import { DevLoggerGroupDebounced } from 'middleware/logger';
import marketplace from 'cfg/marketplace.json';

const TriggerAssignmentDevLogger = new DevLoggerGroupDebounced({
  groupName: '[ASSIGNMENTS]',
  debounceTime: 600
});

export const triggerAssignment = testName => dispatch => {
  if (typeof dispatch === 'function') {
    TriggerAssignmentDevLogger.addLog(`triggerAssignment action dispatched for test: ${testName}`);
  }
  return dispatch(ab.actions.triggerAssignmentFactory({ domain: marketplace.cookieDomain })(testName));
};

export const { isAssigned } = ab;

// Set rrh cookiename
ab.config.setConfig('cookieName', IS_DEV ? 'zfc-dev' : 'zfc');

export function isInAssignment(assignment) {
  return assignment && assignment.index !== 0;
}

export function getAssignmentGroup(name, state) {
  return state ? ab.assignmentGroup(name, state) : 0;
}
